// extracted by mini-css-extract-plugin
export default {"colAction":"OTWMSTEjJ6a7NvbevXLg","colName":"oD5nEg6cRzkXW5RfrinA"};